import { Card, CardHeader, Grid } from "@mui/material";
import { useCallback, useState } from "react";
import { UploadSingleFile } from "src/components/upload";
import useLocales from "src/hooks/useLocales";

import SaveFileBtn from "./SaveFileBtn";

// ----------------------------------------------------------------------

export const UploadCompanyManagmentFile = () => {
	const [file, setFile] = useState<File | any>(null);

	const handleDrop = useCallback((acceptedFiles: any) => {
		const file = acceptedFiles[0];
		if (file) {
			setFile(file);
		}
	}, []);

	const { translate } = useLocales();

	return (
		<Card>
			<CardHeader title={translate("Añadir CSV gestora")} />
			<Grid container spacing={3} sx={{ p: 3 }}>
				<Grid item xs={12}>
					<UploadSingleFile
						accept={{
							"text/csv": [".csv"]
						}}
						file={file}
						onDrop={handleDrop}
						onRemove={() => setFile(null)}
					/>
				</Grid>
				<Grid item lg={12} md={12} xs={12}>
					<SaveFileBtn file={file} />
				</Grid>
			</Grid>
		</Card>
	);
};

export default UploadCompanyManagmentFile;
